import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=190c0526&"
import script from "./LinkList.vue?vue&type=script&lang=js&"
export * from "./LinkList.vue?vue&type=script&lang=js&"
import style0 from "./LinkList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList,VListItem,VListItemContent})
